export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <span className={`logo ${compact ? 'logo--compact' : ''}`} aria-label="Kidee">
      <span>K</span><span>i</span><span>d</span><span>e</span><span>e</span><b>★</b>
    </span>
  );
}
